import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'i2g-company-logo',
  templateUrl: 'company-logo.component.html',
  styleUrls: ['company-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyLogoComponent {
  /**
   * image url attribute
   */
  @Input() imageUrl: string;

  /**
   * image alt attribute
   */
  @Input() imageAlt: string;

  constructor() {}
}
